import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface I_InternetMailOrderFormMeta {
    
    // Internet / Mail Order
    internetOrder: FormInputMeta;
    mailOrder: FormInputMeta;
}

const internetMailOrderFormMeta = {} as I_InternetMailOrderFormMeta;

// Internet / Mail Order Form Fields
internetMailOrderFormMeta.internetOrder = {
    name: "internetOrder",
    type: "checkbox",
    label: "Ordre Internet",
    placeholder: "",
    validation: yup.boolean()
};

internetMailOrderFormMeta.mailOrder = {
    name: "mailOrder",
    type: "checkbox",
    label: "Ordre Mail",
    placeholder: "",
    validation: yup.boolean()
};

export default internetMailOrderFormMeta;